import { ApiError } from '../errors/api-error.js';

export class IdentityProviderService {
    constructor(api) {
        this.api = api;
    }

    async list() {
        try {
            const body = await this.api.list();
            return { success: true, data: body.data || [] };
        } catch (error) {
            throw this._handleError(error, 'Sağlayıcılar alınamadı');
        }
    }

    async create(data) {
        try {
            const body = await this.api.create(data);
            return { success: true, data: body.data };
        } catch (error) {
            throw this._handleError(error, 'Sağlayıcı oluşturulamadı');
        }
    }

    async update(id, data) {
        try {
            const body = await this.api.update(id, data);
            return { success: true, data: body.data };
        } catch (error) {
            throw this._handleError(error, 'Sağlayıcı güncellenemedi');
        }
    }

    async remove(id) {
        try {
            await this.api.remove(id);
            return { success: true };
        } catch (error) {
            throw this._handleError(error, 'Sağlayıcı silinemedi');
        }
    }

    async rotateApiKey(id) {
        try {
            const body = await this.api.rotateApiKey(id);
            return { success: true, data: body.data };
        } catch (error) {
            throw this._handleError(error, 'Anahtar üretilemedi');
        }
    }

    async testOidc(id) {
        try {
            const body = await this.api.testOidc(id);
            return { success: true, data: body.data };
        } catch (error) {
            throw this._handleError(error, 'OIDC keşfi başarısız');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.response) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
